import React from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import currentUserState from "utils/currentUserState";
import APILink from "components/ui/APILink";
import { IconListItem } from "./IconListItem";

export function FinaidSummaryLink() {
  const { finaidYearId } = useParams();
  const {
    isDelegate,
    linkFinaidSummary,
    linkFinaidSummaryDelegate,
    canSeeFinAidSummaryLink,
  } = useSelector((state) => {
    const {
      myStatus: {
        delegateActingAsUid,
        academicRoles: { current: { ugrd, grad, law, summerVisitor } } = {},
        roles: { registered, exStudent },
      } = {},
    } = state;
    const {
      finaid: {
        [finaidYearId]: {
          finaidAwards: {
            linkFinaidSummary,
            linkFinaidSummaryDelegate,
            matriculated,
          } = {},
        } = {},
      } = {},
    } = currentUserState(state);

    const canSeeFinAidSummaryLink =
      !summerVisitor &&
      (matriculated || registered || exStudent) &&
      (ugrd || grad || law);

    return {
      canSeeFinAidSummaryLink,
      linkFinaidSummary,
      linkFinaidSummaryDelegate,
      isDelegate: !!delegateActingAsUid,
    };
  });

  if (linkFinaidSummary && canSeeFinAidSummaryLink) {
    return (
      <IconListItem icon="clipboard-list">
        <div>
          <strong>My Financial Aid Summary Report</strong>
        </div>
        <APILink
          link={isDelegate ? linkFinaidSummaryDelegate : linkFinaidSummary}
        />
      </IconListItem>
    );
  }

  return null;
}

FinaidSummaryLink.displayName = "FinaidSummaryLink";
